import { ReactElement } from 'react';
import CatImage from '@components/CatImage';
import { CatImageVariantT } from '@components/CatImage/dictionary';

interface AvatarCatPropsI {
  width?: number;
  height?: number;
  variant?: CatImageVariantT;
}

const AvatarCat = ({
  width = 72,
  height = 72,
  variant = 'welcome',
}: AvatarCatPropsI): ReactElement => {
  return (
    <div className="flex rounded-full bg-[#d2dff9] overflow-hidden justify-center items-center">
      <CatImage variant={variant} width={width} height={height} />
    </div>
  );
};

export default AvatarCat;
